
import { CplusDocumentTypeShortHand } from '@/jbi-shared/types/document.types';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { StagingEditorCommonMixin } from '../mixins/staging-editor-common.mixin';
import AssigneeInput from '@/views/DocumentEditor/components/AssigneeInput.vue';
import UploadTdrForm from '@/components/form/UploadTdrForm.vue';
import PendingDocumentSettingsForm from './PendingDocumentSettingsForm.vue';
import { DirtyTagMap } from '@/store/modules/documents/types/documents.types';

@Component({
  components: {
    AssigneeInput
  }
})
export default class StagingEditorHeaderDocInfo extends mixins(
  StagingEditorCommonMixin
) {
  get defaultDocDisplayId() {
    if (!this.documentDetail) {
      return;
    }
    const existingCplusDocument = this.getExistingCplusDocumentFromPendingDocument(
      this.documentDetail!
    );
    if (!existingCplusDocument) {
      return `New`;
    } else {
      return `JBI-${
        CplusDocumentTypeShortHand[existingCplusDocument.documentType]
      }-${existingCplusDocument.id}`;
    }
  }

  get updatePublishStatusLoading() {
    return false;
  }

  get resourceUrl() {
    if (this.tdrUri) {
      return this.tdrUri.replace('gs://', 'https://storage.googleapis.com/');
    }
    return '';
  }

  public openUploadTdr() {
    this.$buefy.modal.open({
      parent: this,
      component: UploadTdrForm,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Edit Technical Development Reports'
      },
      events: {
        'update:tdr': this.handleUpdateTdr
      }
    });
  }

  public handleUpdateTdr(tdrUri: string) {
    this.tdrUri = tdrUri;
  }

  public openDocumentSettings() {
    this.$buefy.modal.open({
      parent: this,
      component: PendingDocumentSettingsForm,
      hasModalCard: true,
      trapFocus: true,
      props: {
        documentId: this.documentDetail?.id
      },
      events: {
        'update:tags': (newTags: DirtyTagMap[]) => {
          this.dirtyTagMaps = newTags;
          // Update documentDetail.content.tags to sync with saved state
          if (this.documentDetail && this.documentDetail.content) {
            this.$set(this.documentDetail.content, 'tags', newTags);
          }
          // Reset tags changed state since we just saved the changes
          this.resetTagsChangedState();
        }
      }
    });
  }
}
